<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />

		<section class="main-content background-color">
			<filter-buttons :items="categories" :filter="filter" @change-filter="filter = $event" />
			<image-grid :items="galleryFiltered" :filter="filter" @change-filter="filter = $event" />
		</section>

		<contentblocks v-if="page && page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />
		<review-slider
			v-if="page && page.showReviewSlider"
			:key="$route.path"
			:header="defaults[locale].website.reviewsHeader"
		/>

		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].website.newsletterHeader"
			:content="defaults[locale].website.newsletterContent"
			:button="defaults[locale].website.newsletterButton"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const filter = ref('showAll');

const { data: gallery } = await useWebsiteFetch('gallery', {
	query: { language: locale.value },
	key: `${locale.value}/gallery`,
});

const categories = [
	...new Set(gallery.value.map(({ galleryCategorie }) => galleryCategorie && galleryCategorie.header)),
];

const galleryFiltered = computed(() => {
	if (filter.value === 'showAll') {
		return gallery.value;
	}

	return [...gallery.value].filter((item) => {
		if (!item.galleryCategorie) {
			return false;
		}

		return item.galleryCategorie.header === filter.value;
	});
});
</script>

<style lang="scss" scoped>
.main-content {
	padding: 100px 0;
}

.items {
	a {
		cursor: pointer;
	}

	.filter-item {
		opacity: 0;
		transform: scale(0);
		width: 0;
		padding: 0;
		margin: 0;
		transition: ease-in-out 0.4s all;

		&.active {
			opacity: 1;
			margin: 1em 0;
			padding: 0 1em;
			width: 25%;
			transform: scale(1);
			visibility: visible;
		}
	}
}

.video {
	.overlay {
		width: 100%;
		top: 0;
		height: 100%;
		background-color: rgb(0 0 0 / 50%);
		left: 0;
		position: absolute;
		transition: ease 0.5s all;
	}

	span {
		left: 0;
		right: 0;
		bottom: 0;
		background: transparent;
	}

	.fa-play {
		transition: ease 0.5s all;
		font-size: 25px;
		color: rgb(255 255 255 / 80%);
		position: relative;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
}
</style>
